// extracted by mini-css-extract-plugin
export default {"template":"Template_template__k2O-e","templateSnapShot":"Template_templateSnapShot__WqisB"};